import { lazy } from 'react';
import { ROUTES } from './constants';

import { NotFound } from '../components/ui-helpers';
import { AuthLayout, MainLayout } from '../layouts';

const Overview = lazy(() => import('../containers/overview'));
const TaskPage = lazy(() => import('../containers/task-page'));
const TasksPage = lazy(() => import('../containers/tasks-page'));
const InviteUser = lazy(() => import('../containers/invite-user'));
const SignInForm = lazy(() => import('../containers/sign-in-form'));
const CompanyPage = lazy(() => import('../containers/company-page'));
const RequestPage = lazy(() => import('../containers/request-page'));
const RequestsPage = lazy(() => import('../containers/requests-page'));
const ContactsPage = lazy(() => import('../containers/contacts-page'));
const CompaniesPage = lazy(() => import('../containers/companies-page'));
const MeetingNotesList = lazy(() => import('../containers/meeting-notes'));
const GoogleAuthCallback = lazy(() => import('../containers/google-auth'));
const ProfileSettings = lazy(() => import('../containers/profile-settings'));
const RequestsStatistics = lazy(() => import('../containers/statistics-page'));
const ForgotPasswordForm = lazy(() => import('../containers/forgot-password-form'));
const RestorePasswordForm = lazy(() => import('../containers/restore-password-form'));
const ClientsFeedbackPage = lazy(() => import('../components/clients-feedback-page'));
const ContactsThreadsPage = lazy(() => import('../containers/contacts-threads-page'));

export const appRouteMap = [
  {
    layout: AuthLayout,
    routes: [
      [ROUTES.SIGN_IN, SignInForm],
      [ROUTES.GOOGLE_AUTH_CALLBACK, GoogleAuthCallback],
      [ROUTES.RESTORE_PASSWORD, RestorePasswordForm],
      [ROUTES.FORGOT_PASSWORD, ForgotPasswordForm],
      [ROUTES.INVITE_USER, InviteUser],
      [ROUTES.EDIT_USER_DATA, ProfileSettings],
      [ROUTES.CLIENTS_FEEDBACK, ClientsFeedbackPage],
    ],
  },
  {
    layout: MainLayout,
    routes: [
      [ROUTES.TASKS, TasksPage],
      [ROUTES.TASK, TaskPage],
      [ROUTES.REQUESTS, RequestsPage],
      [ROUTES.REQUEST, RequestPage],
      [ROUTES.CONTACTS, ContactsPage, true],
      [ROUTES.CONTACTS_MESSAGES, ContactsThreadsPage],
      [ROUTES.STATISTICS, RequestsStatistics],
      [ROUTES.OVERVIEW, Overview],
      [ROUTES.NOT_FOUND, NotFound],
      [ROUTES.MEETING_NOTES, MeetingNotesList],
      [ROUTES.HOME, Overview, true],
      [ROUTES.COMPANY, CompanyPage],
      [ROUTES.COMPANIES, CompaniesPage],
    ],
  },
];



// WEBPACK FOOTER //
// ./src/routes/route-configs.js